
var angularModule = angular.module('clientDashboardApp') ;

angularModule.service("confirmService", function($q, $uibModal, $window) {
  this.DELETE = 'delete';
  this.WARNING = 'warning';
  this.QUESTION = 'question';

  var themes = {
    'question': {
      icon: 'question-circle'
    },
    'delete': {
      icon: 'trash',
      className: 'delete'
    },
    'warning': {
      icon: 'exclamation-triangle',
      className: 'warning'
    }
  };

  /**
   * Prompts the user to accept / decline a message
   * @param heading  - String, heading for the confirmation modal
   * @param message  - String, message shown in the confirmation modal
   * @param theme    - String, theme to use in confirmation modal
   * @param optOutKey   - String, key to use in localStorage for a "don't show again" value
   * @param dismissText   - String, if set be displayed next to dismiss checkbox instead of default text
   * @returns Promise[boolean] - promise that resolves to a boolean, true if the user confirms, false otherwise.
   */
  this.confirm = function(heading, message, theme, optOutKey, dismissText) {
    return this.confirmWithOptions({ heading, message, theme, optOutKey, dismissText }).then(
      () => true,
      () => false
    )
  };

  this.confirmWithOptions = function({ heading, message, theme, template, templateUrl, initialModel, optOutKey, dismissText }) {
    let cancel = { reject: false, label: 'Cancel', btnType: 'btn-outline-secondary' };
    let confirm = { resolve: true, label: 'OK', btnType: 'btn-secondary' };
    return this.prompt({
      heading, message, theme, template, templateUrl, initialModel, optOutKey, dismissText,
      actions: [cancel, confirm],
      defaultAction: cancel,
      defaultOptOutAction: {resolve: true}
    }).then(
      ({ params }) => params,
      ({ params }) => $q.reject(params)
    )
  }

  /**
   * Like above, but more flexible, though verbose: Prompts the user with a set of defined button actions
   * @param heading  - String, heading for the confirmation modal
   * @param message  - String, message shown in the confirmation modal
   * @param actions  - Array[Object], { [resolve: Any] [reject: Any], label: String, [btnType: String] }
   * @param defaultAction   - Object`, action object like above actions
   * @param theme    - String, theme to use in confirmation modal
   * @param optOutKey   - String, if set will allow the user to skip confirmation in the future
   * @param dismissText   - String, if set be displayed next to dismiss checkbox instead of default text
   * @param defaultoptOutKeyAction - Object, which action to perform if user has previously opted out: { resolve|reject: value }
   * @param template - optional, template html to render. Can modify a scope that is passed back to
   * @param templateUrl - optional
   * @param initialModel - optional, initialize scope parameters for template
   * @returns Promise[Any] - promise that resolves to object { value: ..., params: ... }
   *                         where resolve is selected action's resolve value,
   *                         and params are scope variables of @param template,
   *                         - rejects with { value: ..., params: ... } like resolve
   *                         Defaults to rejecting with defaultAction or value field is propagated rejection
   */
  this.prompt = function({ heading, message, actions, defaultAction, theme, template, templateUrl, initialModel, optOutKey, dismissText, defaultOptOutAction }) {


    if (optOutKey && $window.localStorage.getItem(optOutStorageKey(optOutKey))) {
      // Return the resolve/reject from default, or just resolve true if not set
      return (defaultOptOutAction && defaultOptOutAction.resolve ? $q.resolve(defaultOptOutAction.resolve) : defaultOptOutAction.reject ? $q.reject(defaultOptOutAction.reject) : $q.resolve(true))
        || $q.resolve(true)
    }

    var subTemplateOrUrl = templateUrl ?
      `<ng-include src="'${templateUrl}'" ng-controller="subTemplateController"></ng-include>` :
      `<div ng-controller="subTemplateController">${template || ''}</div>`;

    var wrappedWithConfirmTemplate = `<div class="{{ theme.className }}">
      <div class="modal-header">
        <h5>{{ heading }}</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-3 text-center">
            <i class="fas fa-{{theme.icon}} fa-2x"></i>
          </div>
          <div class="col-9 d-flex align-items-center">
            <div ng-bind-html="message"></div>
            ${subTemplateOrUrl}
          </div>
        </div>
      </div>
    
      <div class="modal-footer">
        <span ng-show="optOutKey">
            <label><input type="checkbox" ng-model="skipInFuture" ng-value="true" /> ${dismissText || "Don't ask again"}</label>
        </span>
        <button ng-if="!questions" ng-repeat="action in actions" class="btn {{action.btnType}}" type="button"
                ng-click="close(action)">{{ action.label }}
        </button>
      </div>
    </div>`;


    var modalInstance = $uibModal.open({
      template: wrappedWithConfirmTemplate,
      controller: ($scope) => {

        Object.assign($scope, {
          heading, message, template, templateUrl, actions, optOutKey,
          theme: theme && themes[theme],
          subTemplateController: ['$scope', function ($scope) {

            Object.assign($scope, initialModel);
            function getScopeValues() {
              // ugly hack, just use the whole $scope (or child scope if in a ng-included template)
              var s = templateUrl ? $scope.$$childHead : $scope;
              return Object.keys(s).filter(x => x[0] !== '$').reduce((soFar, x) => {
                soFar[x] = s[x];
                return soFar;
              }, {})
            }

            $scope.$on('confirmCloseSubmitted', () => {
              $scope.$emit('confirmParametersRetrieved', getScopeValues())
            })
          }],
          close(action) {
            $scope.$on('confirmParametersRetrieved', (event, data) => {
              modalInstance.close({ action: action, params: data, skipInFuture: $scope.skipInFuture })
            });

            // retrieve the scope from the subtemplate through some back and forth events
            $scope.$broadcast('confirmCloseSubmitted')
          }
          // TODO retrieve parameters if they clicked outside the modal to reject it
        })
      }
    });

    return $q((resolve, reject) => { // not sure if this actually needs the promise wrapper
      function exec({ action, params, skipInFuture }) {
        if (skipInFuture && optOutKey) {
          $window.localStorage.setItem(optOutStorageKey(optOutKey), true)
        }
        if (angular.isDefined(action.resolve)) {
          resolve({ value: action.resolve, params });
        } else {
          reject({ value: action.reject, params });
        }
      }
      modalInstance.result.then(
        exec, (err) => exec({ action: (defaultAction || { reject: err }) }))

    });
  };

  function optOutStorageKey(name) {
    return `confirm.optOut.${name}`
  }

});
